import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserInformationService {
  private rootUrl: string = environment.baseUrl;
  private getUserInformationFromSignupUrl = this.rootUrl + 'api/customers/users/';

  constructor(private httpClient: HttpClient) { }

  public getUserInformationByEmail(email: string): Observable<any> {
    return this.httpClient.get<any>(this.getUserInformationFromSignupUrl + email);
  }

  public getAnalyticsDetails(filter): Observable<any> {
    // filter.customerKey = '41143';
    return this.httpClient.post<any>(this.rootUrl + 'api/sso/getCustomerPortalAnalyticsReferences', filter);
  }

  public getJWTToken(filter): Observable<any> {
    return this.httpClient.post<any>(this.rootUrl + 'api/sso/login', filter);
  }

  public updateAggregateTemplate(data): Observable<any> {
    return this.httpClient.post<any>(this.rootUrl + 'uploadAggreementTemplate', data);
  }

  public getQuickSightDashboardUrl(data): Observable<any> {
    return this.httpClient.post<any>(this.rootUrl + 'api/customer/quicksitedashboard/url', data);
  }

  public getQuickSightCustomerDetails(data): Observable<any> {
    return this.httpClient.get<any>(this.rootUrl + 'api/customer/quicksitedashboard/getQuicksiteArn/' + data);
  }
}
